import React from 'react'

const Footer = () => {
  return (
    <footer id="footer">
      <h2>Powered By Bright-LB</h2>
    </footer>
  )
}

export default Footer